import API from "serviceshift-ui/api-client";

export default {
  addTag(_, data) {
    return API.makeRequest(`/v3/tags/${data.tag_id}/tag_${data.tag_type}`, {
      method: "POST",
      data
    });
  },
  removeTag(_, data) {
    return API.makeRequest(`/v3/tags/${data.tag_id}/untag_${data.tag_type}`, {
      method: "DELETE",
      data
    });
  },
  fetchTags(_, tag_type) {
    return API.makeRequest(`/v3/tags?type=${tag_type}`, {
      method: "GET"
    });
  },
  fetchTag(_, id) {
    return API.makeRequest(`/v3/tags/${id}`, {
      method: "GET"
    });
  },
  createTag(_, data) {
    return API.makeRequest(`/v3/tags/`, {
      method: "POST",
      data
    });
  },
  updateTag(_, data) {
    return API.makeRequest(`/v3/tags/${data.id}`, {
      method: "PUT",
      data: data.tag
    });
  }
};
